import { Box, Button, IconButton, Tooltip } from "@mui/material"
import Datatable from "../../../components/features/Datatable"
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import BsModal from "../../../components/common/BaseModal";
import { DeleteIconButton, EditIconButton } from "../../../../assets/common-svg/CommonSvg";
import DeleteModal from "../../../components/common/BaseModal/DeleteModal";
import { deleteCity, disableAddModal, enableAddModal, fetchAllCity } from "../../../slices/city";
import AddCityForm from "./addCityForm";

const CityManagement = () => {
    const dispatch = useDispatch()
    const [rowData, setRowData] = useState(null)
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const { isLoading, addModal } = useSelector((state) => state.bmrCity);
    const [filters, setFilters] = useState({});
    const [currentSearch, setCurrentSearch] = useState("");
    const [cityData, setCityData] = useState({
        items: [],
        total_count: 0,
        page: 1,
        per_page: 10,
    })
    const searchDebounceRef = useRef(null);
    const columns = [
        {
            id: 'id',
            name: 'City ID',
            align: "left",
            selector: row => row.id,
            sortable: true
        },
        {
            id: 'country_name',
            align: "center",
            name: 'Country Name',
            selector: row => row.country_details?.name,
            sortable: true
        },
        {
            id: 'state_name',
            align: "center",
            name: 'State Name',
            selector: row => row.state_name,
            sortable: true
        },
        {
            id: 'name',
            name: 'City Name',
            align: "center",
            selector: row => row.name,
            sortable: true
        },
        {
            id: 'city_code',
            align: "center",
            name: 'City Code',
            selector: row => row.city_code,
            sortable: true
        },

        {
            name: 'Action',
            align: "center",
            selector: row => <Box key={row.id}>
                <Tooltip title="Edit" >
                    <span>
                        <IconButton
                            onClick={() => { setRowData(row), handleAddModal() }}
                        >
                            <EditIconButton
                                bgColor={"#C3C3C3"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title={row.is_used ? "Cannot delete: City is in use" : "Delete"} >
                    <span style={{
                        cursor: row.is_used ? 'not-allowed' : 'pointer',
                        display: 'inline-block',
                        pointerEvents: row.is_used ? 'all' : 'auto'
                    }}>
                        <IconButton
                            onClick={() => { if (!row.is_used) { setRowData(row); setOpen(true); } }}
                            sx={{
                                pointerEvents: row.is_used ? 'none' : 'auto',
                            }}
                        >
                            <DeleteIconButton
                                bgColor={"#FA5151"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>,
        },
    ];

    const handleCloseModal = async () => {
        await dispatch(disableAddModal())
    }
    const handleAddModal = async () => {
        await dispatch(enableAddModal())
    }
    const removeCity = async () => {
        const { id } = rowData;
        await dispatch(deleteCity({ id }));
        setOpen(false);
        handleServerSideChange({
            page: cityData.page,
            per_page: cityData.per_page,
            search: currentSearch
        });
    };
    const handleServerSideChange = async (params) => {
        const searchValue = params.search || '';
        setCurrentSearch(searchValue);
        const trimmedSearch = searchValue.trim();

        try {
            setLoading(true);

            if (trimmedSearch === '') {
                const result = await dispatch(fetchAllCity({
                    page: params.page,
                    limit: params.per_page,
                    sort_by: params.sort_by || 'id',
                    order_by: params.sort_order || 'desc'
                })).unwrap();

                setCityData({
                    items: result?.data || [],
                    total_count: result?.page_details?.no_of_records || 0,
                    page: result?.page_details?.page || params.page,
                    per_page: result?.page_details?.limit || params.per_page,
                });

            } else {
                const result = await dispatch(fetchAllCity({
                    page: params.page,
                    limit: params.per_page,
                    search: trimmedSearch,
                    sort_by: params.sort_by || 'id',
                    order_by: params.sort_order || 'desc'
                })).unwrap();
            
                setCityData({
                    items: result?.data || [],
                    total_count: result?.page_details?.no_of_records || 0,
                    page: result?.page_details?.page || params.page,
                    per_page: result?.page_details?.limit || params.per_page,
                });
            }

        } catch (error) {
            console.error("Error fetching city list:", error);
        } finally {
            setLoading(false);
        }
    }
    const updateFilter = (params) => {
        const {
            page = 1,
            per_page = 10,
            search = '',
            ...appliedFilters
        } = params;

        const isFilterChanged = JSON.stringify(filters) !== JSON.stringify(appliedFilters);
        const finalPage = isFilterChanged ? 1 : page;

        setFilters(appliedFilters);
        const isSearchChange = search !== currentSearch;
        if (isSearchChange) {
            if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
            searchDebounceRef.current = setTimeout(() => {
                handleServerSideChange({
                    page: finalPage,
                    per_page,
                    search,
                    sort_by: params.sort_by,
                    sort_order: params.sort_order
                });
            }, 400);
        } else {
            handleServerSideChange({
                page: finalPage,
                per_page,
                search,
                sort_by: params.sort_by,
                sort_order: params.sort_order
            });
        }
    };

    useEffect(() => {
        handleServerSideChange({ page: 1, per_page: 10, search: "" });
    }, []);
    return <div className="!p-6">
        <div className="!p-4 mt-3 bg-white flex flex-col gap-4">
            <BsModal
                open={addModal}
                onClose={handleCloseModal}
                title={rowData ? "Edit City" : "Add New City"}>
                <AddCityForm editData={rowData} onSuccess={() => {
                    handleCloseModal();
                    handleServerSideChange({
                        page: cityData.page,
                        per_page: cityData.per_page,
                        search: currentSearch
                    });
                    setRowData(null);
                }} />
            </BsModal>
            <Datatable
                columns={columns}
                data={{
                    items: cityData.items,
                    total_count: cityData.total_count
                }}
                title="City"
                searchPlaceholder="Search by Country/State/City name"
                loading={isLoading || loading}
                BtnComponent={<Button className="ml-2"
                    onClick={() => (handleAddModal(), setRowData(null))}
                >Add New City</Button>}
                remote={true}
                onServerSideChange={updateFilter}
            />
            <DeleteModal
                open={open}
                setClose={setOpen}
                title={"Are you sure you want to Delete ?"}
                buttonText={"Delete"}
                handleSuccess={removeCity}
            />
        </div>
    </div>
}
export default CityManagement